module.exports = __webpack_public_path__ + "static/img/image_tag_ex_point.32e77d2.png";